import { render } from "./registerlaundry.vue?vue&type=template&id=b3ceeb98"
import script from "./registerlaundry.vue?vue&type=script&lang=js"
export * from "./registerlaundry.vue?vue&type=script&lang=js"

import "./registerlaundry.vue?vue&type=style&index=0&id=b3ceeb98&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__